import { ChangeDetectionStrategy, Component, HostListener, output } from '@angular/core';

@Component({
  selector: 'mng-file-drop',
  templateUrl: './mng-file-drop.component.html',
  styleUrl: './mng-file-drop.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class FileDropComponent {
  readonly fileOver = output<boolean>();
  readonly fileDropped = output<File[]>();

  hasDropZoneOver = false;

  @HostListener('drop', ['$event'])
  onDrop(event: Event) {
    const transfer = this._getTransfer(event);
    if (!transfer) {
      return;
    }

    this._preventAndStop(event);
    this.fileDropped.emit(transfer.files);

    this.fileOver.emit(false);
    this.hasDropZoneOver = false;
  }

  @HostListener('dragover', ['$event'])
  onDragOver(event: Event) {
    const transfer = this._getTransfer(event);
    if (!this._haveFiles(transfer.types)) {
      return;
    }

    transfer.dropEffect = 'copy';
    this._preventAndStop(event);
    this.fileOver.emit(true);
    this.hasDropZoneOver = true;
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave(event: Event) {
    this._preventAndStop(event);
    this.fileOver.emit(false);
    this.hasDropZoneOver = false;
  }

  _addOverClass(item: any): void {
    item.addOverClass();
  }

  _removeOverClass(item: any): void {
    item.removeOverClass();
  }

  private _getTransfer(event: any): any {
    return event.dataTransfer ? event.dataTransfer : event.originalEvent.dataTransfer; // jQuery fix;
  }

  private _preventAndStop(event: any): any {
    event.preventDefault();
    event.stopPropagation();
  }

  private _haveFiles(types: any): boolean {
    if (!types) {
      return false;
    }

    if (types.indexOf) {
      return types.indexOf('Files') !== -1;
    } else if (types.contains) {
      return types.contains('Files');
    } else {
      return false;
    }
  }
}
